// In production, REACT_APP_BACKEND_URL is set at build time (e.g. https://core.honestlee.app)
// In development, falls back to /api which is proxied by setupProxy.js to localhost:8002
//
// v66.139 — defensive: `typeof process` check so we never throw
// "process is not defined" in browsers where vite's process.env replacement
// didn't apply (config not reloaded, etc).
const getApiBaseUrl = () => {
  try {
    const url = (typeof process !== 'undefined' && process?.env?.REACT_APP_BACKEND_URL)
             || (typeof import.meta !== 'undefined' && import.meta.env?.VITE_BACKEND_URL)
             || (typeof import.meta !== 'undefined' && import.meta.env?.REACT_APP_BACKEND_URL);
    if (url) return `${url.replace(/\/$/, '')}/api`;
  } catch { /* swallow — fall through to /api */ }
  return '/api';
};

export const API_BASE_URL = getApiBaseUrl();

export const ONBOARDING_STATUS = {
  UNLISTED: 'UNLISTED',
  LISTED_UNCLAIMED: 'LISTED_UNCLAIMED',
  SOFT_ONBOARDED: 'SOFT_ONBOARDED',
  NOT_INTERESTED: 'NOT_INTERESTED',
  INTERESTED_LATER: 'INTERESTED_LATER',
  FULLY_VERIFIED: 'FULLY_VERIFIED'
};

export const STATUS_COLORS = {
  UNLISTED: '#FF6B6B',
  LISTED_UNCLAIMED: '#FFA07A',
  SOFT_ONBOARDED: '#FFD93D',
  NOT_INTERESTED: '#95A5A6',
  INTERESTED_LATER: '#A8DADC',
  FULLY_VERIFIED: '#6BCF7F'
};

export const PHOTO_TYPES = [
  'storefront',
  'interior',
  'menu',
  'selfie_staff',
  'selfie_owner',
  'selfie_manager',
  'food',
  'outdoor',
  'logo',
  'cover'
];

export const CATEGORIES = [
  'cafe',
  'restaurant',
  'coworking',
  'coffee_shop',
  'thai_food',
  'street_food',
  'bar',
  'hotel'
];